<template>
  <div>
    <receipt-order ref="orders" :order-status="orderStatus" :owners="owners" :refundable="refundable" @clearDetails="clearDetails" @showDetails="showDetails"/>
    <receipt-detail ref="details" :refundable="refundable" @receive="receive"/>
  </div>
</template>

<script>
import ReceiptOrder from '@/views/inbound/receipt/ReceiptOrder.vue'
import ReceiptDetail from '@/views/inbound/receipt/ReceiptDetail.vue'
import { AsnOrder } from '@/api/dto/order/AsnOrder'
import { BaseObject } from '@/api/dto/BaseObject'

export default {
  name: 'ReceiptQuery',
  components: { ReceiptOrder, ReceiptDetail },
  props: {
    refundable: { type: Boolean, default: false },
    orderStatus: { type: Array, default: [] },
    owners: { type: Array, default: [] }
  },
  methods: {
    refresh() {
      this.$refs.orders.fetch()
    },
    showDetails(row) {
      this.$refs.details.refresh(new AsnOrder(BaseObject.merge(row, 'order')))
    },
    clearDetails() {
      this.$refs.details.clear()
    },
    receive(row) {
      this.$emit('receive', row)
    }
  }
}
</script>